import { isMatch, pick } from 'lodash';
import { I18n } from 'react-redux-i18n';

export const examClassesToDropdown = (examClasses) => {
    if (!examClasses)
        return [];
    return examClasses.map(ec => {
        return {value: ec, label: ec};
    });
};

export const LESSON_TYPES = [
    "THEORY",
    "DRIVING",
    "TRAINING"
]

export const lessonTypes = () => LESSON_TYPES.map(type => ({ value: type, label: I18n.t(`app.${type.toLowerCase()}`) }));

export const lessonHasExamClass = (lesson, examClass) => lesson.examClasses.map(ec => ec.name).includes(examClass);

export const shouldSelectExamClass = (searchTerms, examClasses) => {
    return !!searchTerms && (examClasses || []).length === 1 && (!searchTerms.examClass || !examClasses.includes(searchTerms.examClass));
}

export const validLessonType = (lessonType) => {
    return LESSON_TYPES.includes(lessonType);
};

export const addColonIntoTime = (timeString) => {
    timeString = timeString.replace('.', ':')
    if (timeString.split(":").length > 1 ) {
        return timeString;
    }
    if (timeString.length === 4 ) {
        return timeString.slice(0, 2) + ':' + timeString.slice(2);
    }
    else {
        return timeString
    }
};

export const combineCourseToTerms = (terms, currentCourse) => {
    return Object.assign({}, terms || {}, currentCourse || {});
}

const COURSE_IDENTITY_FIELDS = ["courseNumber", "courseYear", "courseUnit"];

export const matchCourse = (courseToMatch) => (course) => {
    return isMatch(course, pick(courseToMatch, COURSE_IDENTITY_FIELDS));
}

export const getLabel = (value, source) => {
    const type = source.filter(o => {
        return o.value === value;
    });
    const label = !type || type.length === 0 ? '' : type[0].label;
    return label;
};



// WEBPACK FOOTER //
// ./src/util/SearchUtil.js